/* eslint-disable no-nested-ternary */
import { FC } from 'react';
import { coreService } from 'network-utils';
import { Icon, Tooltip } from 'learning-panel-components';
import { translate } from 'translations';
import styles from './contentType.module.scss';

const ContentType: FC<ContentTypeProps> = (props: ContentTypeProps) => {
    const { type, isSelected, onClick, isDisabled } = props;

    const contentProperties = {
        videotutorial: { iconName: 'videoLearningPanel', text: translate('Video') },
        course: { iconName: 'courseIconLearningPanel', text: translate('Course') },
        challenge: { iconName: 'challengeIconLearningPanel', text: translate('Challenge') },
        lesson: { iconName: 'lessonIconLearningPanel', text: translate('Lesson') },
        skilltree: { iconName: 'skillTree', text: translate('skillTree') },
        learningpath: { iconName: 'learningPath', text: translate('learningPath') },
        lab: { iconName: 'vulnerabilityFix', text: translate('VulnerabilityFix') }
    };

    return (
        <div
            className={
                isSelected
                    ? styles['selected-content-type']
                    : isDisabled
                    ? styles['disabled-content-type']
                    : styles['content-type']
            }
            onClick={() => (isDisabled ? undefined : onClick())}
        >
            <Tooltip title={contentProperties[type]?.text} placement="top">
                <span>
                    <Icon name={contentProperties[type]?.iconName} />
                </span>
            </Tooltip>
        </div>
    );
};

export default ContentType;

interface ContentTypeProps {
    type: 'videotutorial' | 'course' | 'challenge' | 'lesson' | 'skilltree' | 'learningpath' | 'lab';
    isSelected?: boolean;
    isDisabled?: boolean;
    onClick: Function;
}
